import {createSelector} from 'reselect';

import type {NutshellState} from '../../store';

export const getFormState = (state: NutshellState) => state.webForms;

export const getFormSubmissionsListState = createSelector(
    [getFormState],
    (formState) => formState.formSubmissionsList
);

export const getIsFilterDrawerOpen = createSelector([getFormState], (formState) => {
    return formState.isFilterDrawerOpen;
});

export const getFormSubmissionsListItems = createSelector(
    [getFormSubmissionsListState],
    (formSubmissionsListState) => {
        return formSubmissionsListState.listItems;
    }
);
export const getFormSubmissionsListIsLoading = createSelector(
    [getFormSubmissionsListState],
    (formSubmissionsListState) => {
        return formSubmissionsListState.isLoading;
    }
);
export const getFormSubmissionsListIsFirstLoad = createSelector(
    [getFormSubmissionsListState],
    (formSubmissionsListState) => {
        return formSubmissionsListState.isFirstLoad;
    }
);
export const getFormSubmissionsListHasError = createSelector(
    [getFormSubmissionsListState],
    (formSubmissionsListState) => {
        return Boolean(formSubmissionsListState.errorMessage);
    }
);

export const getFormSubmissionsListCount = createSelector(
    [getFormSubmissionsListState],
    (formSubmissionsListState) => {
        return formSubmissionsListState.meta.count ? formSubmissionsListState.meta.count : 0;
    }
);

// Membership report
const getFormEngagementReportState = createSelector(
    [getFormState],
    (reportState) => reportState.formEngagementReport
);

const getFormEngagementChartState = createSelector(
    [getFormEngagementReportState],
    (formEngagementReport) => formEngagementReport.timeseriesChart
);

export const getCurrentReportChartIsLoading = createSelector(
    [getFormEngagementChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);
export const isChartTimedOut = createSelector(
    [getFormEngagementChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = (state: NutshellState) =>
    getFormEngagementChartState(state).isErrored;

export const getCurrentReportChartData = createSelector(
    [getFormEngagementChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);
export const getCurrentReportChartPrefix = createSelector(
    [getFormEngagementChartState],
    (timeseriesChartState) => timeseriesChartState.prefix
);
export const getCurrentReportChartBucketCount = createSelector(
    [getCurrentReportChartData],
    (chartData) => (chartData ? chartData.buckets.length : 1)
);
export const getFormSchema = createSelector([getFormState], (formState) => formState.formSchema);

export const getFormSchemaFields = createSelector([getFormSchema], (formSchema) => {
    const schemaFields = formSchema.properties;
    const fields = Object.keys(schemaFields)
        // don't show fields that aren't enabled (rare case, but used for migrations)
        .filter((key) => schemaFields[key].isEnabled)
        // get array of all schema fields by key
        .map((key) => schemaFields[key]);

    return fields;
});
